import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import ErrorDisplay from "../error-display";
import HttpRequest from "../../../services/HttpRequest";

interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const errorDescription = `${error.toString()}\n${errorInfo.componentStack}`;
    const errorPath = this.props.location.pathname;

    HttpRequest.request({
      url: "/error/log",
      method: "POST",
      data: {
        errorPath,
        errorDescription,
      }
    }).catch((err) => {
      console.error("Error log sending failed:", err);
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorDisplay />;
    }

    return <>{this.props.children}</>;
  }

}

export default withRouter(ErrorBoundary);
